import { render } from "./AvatarLetter.vue?vue&type=template&id=bdff6d34"
import script from "./AvatarLetter.vue?vue&type=script&lang=js"
export * from "./AvatarLetter.vue?vue&type=script&lang=js"

import "./AvatarLetter.vue?vue&type=style&index=0&id=bdff6d34&lang=scss"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__